import { render } from "./App.vue?vue&type=template&id=492f963c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=492f963c&lang=css"

import exportComponent from "C:\\laragon\\www\\textron\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__